import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-credits-card',
  templateUrl: './credits-card.component.html',
  styleUrls: ['./credits-card.component.scss']
})
export class CreditsCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
